import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { PipesModule } from '../../pipes/pipes.module';
import { UtilService } from '../../services/util.service';
import { ConceptsDescriptionModalComponent } from './concepts-description-modal.component';

@NgModule({
    declarations: [
        ConceptsDescriptionModalComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        MatTooltipModule
    ],
    exports: [
        ConceptsDescriptionModalComponent
    ],
    providers: [
        UtilService
    ]
})
export class ConceptsDescriptionModalModule { }
